import { TableRow } from './TableRow';

export default TableRow;
